const LOANS = {
  ID: {
    FIVE_MONTH: 'fiveMonth',
    NINE_MONTH: 'nineMonth',
    SOCIAL_HOUSING_LOAN: 'socialHousingLoan',
    AGREEMENT_HOUSING_LOAN: 'agreementHousingLoan',
    SOCIAL_HOUSING_LOAN_FIXED: 'socialHousingLoanFixed',
    AGREEMENT_HOUSING_LOAN_FIXED: 'agreementHousingLoanFixed',
    VARIOUS_CREDIT: 'variousCredit',
    DIVERSAL_ATENTION:'diversalAtention',
    ISADHESIVO:'isAdhesivo',
  },
  ID_HR: {
    FIVE_MONTH: '5S',
    NINE_MONTH: '9S',
    SOCIAL_HOUSING_LOAN: 'SV',
    AGREEMENT_HOUSING_LOAN: 'VC',
    VARIOUS_CREDIT: 'CV',
    DIVERSAL_ATENTION:'AD',
    HOUSING_MANDATORY_PURPOSE: '09',
    ISADHESIVO:'isAdhesivo',
  },
  STATES: {
    ID: {
      AUTHORIZED: 'A',               // Autorizado -> Autorizado
      NOT_IN_FORCE: 'N',             // No vigente -> No vigente
      ANNULATED: 'B',                // Anulado -> No vigente
      DISCLAIMER: 'C',               // Renunciado -> No vigente
      REGRESSED: 'R',                // Retrocedido -> No vigente
      CANCELLED: '0',                // Cancelado -> No vigente
      DENIED: 'D',                   // Denegado -> Denegado
      IN_FORCE: 'L',                 // En vigor -> En vigor
      SUBSCRIBER: 'X',               // Abonado -> En vigor
      PENDING: 'P',                  // Pendiente -> Pendiente
      PENDING_SIGNATURE: 'F',        // Pendiente de firma -> Pendiente de firma
      IN_STUDIO: '1',                // Activo -> ?
      TRANSITIONAL_INTEGRATION: 'Z', // Transitorio integración -> ?
    },
  },
  STATUS: {
    OK: 'OK',
    KO: 'KO',
  },
  LINKS: {
    RECEIPTS: 'https://bbva-intranet.appspot.com?atom=00000159&external=true',
    POLICY: 'https://portalintranet.es.igrupobbva/EHRA/ehra_mult_web_ehragestor_02/parameterGestorController',
    TAX: 'https://portalintranet.es.igrupobbva/EHRA/ehra_mult_web_ehragestorrecibosirpf_05/parameterRecibosIrpfController',
  },
};

const REPAYMENT_TYPES = {
  PARTIAL: 'partial',
  TOTAL: 'total',
  SIMULATE: 'simulate'
};

const AMORTIZATION = {
  FEE: 'C',
  PERIOD: 'P',
};

const MIN_LENGTH_OF_SERVICE_FOR_SIGN_UP = 2;

const LOANS_MODAL_STATES = {
  DETAILS: 'details',
  SOCIAL_HOUSING_LOAN: 'socialHousingLoan',
  CADASTRAL_REFERENCE: 'cadastralReference',
  CLOSE_CADASTRAL_REFERENCE: 'closeCadastralReference',
  SHOW_JUSTIFICATION: 'showJustificationInformation',
  SHOW_JUSTIFICATION_MAIL: 'showJustificationMailInformation',
  DETAILSADHESION: 'adhesion',
};

const LOANS_REPAYMENT_SWITCH_CONFIG = [
  {
    text: 'GLOBALS.BUTTON_ACTION.PARTIAL',
    value: 'simulate',
  },
  {
    text: 'GLOBALS.BUTTON_ACTION.TOTAL',
    value: 'total',
  }
];

const LOANS_CREDITWORTHINESS_MODAL_COACHMARK_CONFIG = {
  module:'LOANS',
  tab:'creditworthiness',
  state:'my-creditworthiness',
  title: 'LOANS.COACHMARK.CREDITWORTHINESS.TITLE',
  subtitles:[
    {
      text:'LOANS.COACHMARK.CREDITWORTHINESS.STEP0'
    }
  ],
  imgs:[
    {
      source:'img/welcome-modal/loans/01-MCW/01.png',
      alt:'GLOBALS.COACHMARK.SLIDE_IMG_ALT'
    }
  ]
};

const LOANS_NEED_A_LOAN_MODAL_COACHMARK_CONFIG = {
  module:'LOANS',
  tab:'needALoan',
  state:'need-a-loan',
  title: 'LOANS.COACHMARK.NEED_A_LOAN.TITLE',
  subtitles:[
    {
      text:'LOANS.COACHMARK.NEED_A_LOAN.STEP0'
    },{
      text:'LOANS.COACHMARK.NEED_A_LOAN.STEP1'
    },{
      text:'LOANS.COACHMARK.NEED_A_LOAN.STEP2'
    },{
      text:'LOANS.COACHMARK.NEED_A_LOAN.STEP3'
    }
  ],
  imgs:[
    {
      source:'img/welcome-modal/loans/02-NAL/01.png',
      alt:'GLOBALS.COACHMARK.SLIDE_IMG_ALT'
    },{
      source:'img/welcome-modal/loans/02-NAL/02.png',
      alt:'GLOBALS.COACHMARK.SLIDE_IMG_ALT'
    },{
      source:'img/welcome-modal/loans/02-NAL/03.png',
      alt:'GLOBALS.COACHMARK.SLIDE_IMG_ALT'
    },{
      source:'img/welcome-modal/loans/02-NAL/04.png',
      alt:'GLOBALS.COACHMARK.SLIDE_IMG_ALT'
    }
  ]
};

const LOANS_CATALOG_MODAL_COACHMARK_CONFIG = {
  module:'LOANS',
  tab:'catalog',
  state:'catalog',
  title: 'LOANS.COACHMARK.LOANS_CATALOG.TITLE',
  subtitles:[
    {
      text:'LOANS.COACHMARK.LOANS_CATALOG.STEP0'
    },{
      text:'LOANS.COACHMARK.LOANS_CATALOG.STEP1'
    },{
      text:'LOANS.COACHMARK.LOANS_CATALOG.STEP2'
    },{
      text:'LOANS.COACHMARK.LOANS_CATALOG.STEP3'
    },{
      text:'LOANS.COACHMARK.LOANS_CATALOG.STEP4'
    },{
      text:'LOANS.COACHMARK.LOANS_CATALOG.STEP5'
    }
  ],
  imgs:[
    {
      source:'img/welcome-modal/loans/03-LC/01.png',
      alt:'GLOBALS.COACHMARK.SLIDE_IMG_ALT'
    },{
      source:'img/welcome-modal/loans/03-LC/02.png',
      alt:'GLOBALS.COACHMARK.SLIDE_IMG_ALT'
    },{
      source:'img/welcome-modal/loans/03-LC/03.png',
      alt:'GLOBALS.COACHMARK.SLIDE_IMG_ALT'
    },{
      source:'img/welcome-modal/loans/03-LC/04.png',
      alt:'GLOBALS.COACHMARK.SLIDE_IMG_ALT'
    },{
      source:'img/welcome-modal/loans/03-LC/05.png',
      alt:'GLOBALS.COACHMARK.SLIDE_IMG_ALT'
    },{
      source:'img/welcome-modal/loans/03-LC/06.png',
      alt:'GLOBALS.COACHMARK.SLIDE_IMG_ALT'
    }
  ]
};

const LOANS_MY_LOANS_MODAL_COACHMARK_CONFIG = {
  module:'LOANS',
  tab:'myLoans',
  state:'my-loans',
  title: 'LOANS.COACHMARK.MY_LOANS.TITLE',
  subtitles:[
    {
      text:'LOANS.COACHMARK.MY_LOANS.STEP0'
    },{
      text:'LOANS.COACHMARK.MY_LOANS.STEP1'
    },{
      text:'LOANS.COACHMARK.MY_LOANS.STEP2'
    },{
      text:'LOANS.COACHMARK.MY_LOANS.STEP3'
    },{
      text:'LOANS.COACHMARK.MY_LOANS.STEP4'
    }
  ],
  imgs:[
    {
      source:'img/welcome-modal/loans/04-ML/01.png',
      alt:'GLOBALS.COACHMARK.SLIDE_IMG_ALT'
    },{
      source:'img/welcome-modal/loans/04-ML/02.png',
      alt:'GLOBALS.COACHMARK.SLIDE_IMG_ALT'
    },{
      source:'img/welcome-modal/loans/04-ML/03.png',
      alt:'GLOBALS.COACHMARK.SLIDE_IMG_ALT'
    },{
      source:'img/welcome-modal/loans/04-ML/04.png',
      alt:'GLOBALS.COACHMARK.SLIDE_IMG_ALT'
    },{
      source:'img/welcome-modal/loans/04-ML/05.png',
      alt:'GLOBALS.COACHMARK.SLIDE_IMG_ALT'
    }
  ]
};

const LOANS_WAGE_ADVANCE_MODAL_COACHMARK_CONFIG = {
  module:'LOANS',
  tab:'waveAdvance',
  state:'wage-advance',
  title: 'LOANS.COACHMARK.WAGE_ADVANCE.TITLE',
  subtitles:[
    {
      text:'LOANS.COACHMARK.WAGE_ADVANCE.STEP0'
    },{
      text:'LOANS.COACHMARK.WAGE_ADVANCE.STEP1'
    }
  ],
  imgs:[
    {
      source:'img/welcome-modal/loans/05-WA/01.png',
      alt:'GLOBALS.COACHMARK.SLIDE_IMG_ALT'
    },{
      source:'img/welcome-modal/loans/05-WA/02.png',
      alt:'GLOBALS.COACHMARK.SLIDE_IMG_ALT'
    }
  ]
};

export {
  LOANS,
  REPAYMENT_TYPES,
  AMORTIZATION,
  MIN_LENGTH_OF_SERVICE_FOR_SIGN_UP,
  LOANS_MODAL_STATES,
  LOANS_REPAYMENT_SWITCH_CONFIG,
  LOANS_CREDITWORTHINESS_MODAL_COACHMARK_CONFIG,
  LOANS_CATALOG_MODAL_COACHMARK_CONFIG,
  LOANS_MY_LOANS_MODAL_COACHMARK_CONFIG,
  LOANS_WAGE_ADVANCE_MODAL_COACHMARK_CONFIG,
  LOANS_NEED_A_LOAN_MODAL_COACHMARK_CONFIG,
};



// WEBPACK FOOTER //
// ./client/app/loans.module/common/domain/constants.loans.js